import { useEffect, useState } from "react";
import { orderActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useBulkPinPurchaseOrder = () => {
    const dispatch = useAppDispatch();
    const [isPinning, setIsPinning] = useState(false);
    const [isUnpinning, setIsUnpinning] = useState(false);

    const { bulkPinningPurchaseOrder, bulkPinPurchaseOrderSuccess, bulkPinPurchaseOrderFailure } =
        useAppSelector((state) => state.order);
    const {
        bulkUnpinningPurchaseOrder,
        bulkUnpinPurchaseOrderSuccess,
        bulkUnpinPurchaseOrderFailure,
    } = useAppSelector((state) => state.order);

    const handleBulkPin = (poIds: string[]) => {
        setIsPinning(true);
        dispatch(orderActions.bulkPinPurchaseOrder({ purchaseOrderIds: poIds }));
    };

    const handleBulkUnpin = (poIds: string[]) => {
        setIsUnpinning(true);
        dispatch(orderActions.bulkUnpinPurchaseOrder({ purchaseOrderIds: poIds }));
    };

    useEffect(() => {
        if (bulkPinPurchaseOrderSuccess && isPinning) {
            setIsPinning(false);
            dispatch(orderActions.resetBulkPinPurchaseOrderSuccess());
        }
    }, [bulkPinPurchaseOrderSuccess, isPinning, dispatch]);

    useEffect(() => {
        if (bulkPinPurchaseOrderFailure && isPinning) {
            setIsPinning(false);
        }
    }, [bulkPinPurchaseOrderFailure, isPinning]);

    useEffect(() => {
        if (bulkUnpinPurchaseOrderSuccess && isUnpinning) {
            setIsUnpinning(false);
            dispatch(orderActions.resetBulkUnpinPurchaseOrderSuccess());
        }
    }, [bulkUnpinPurchaseOrderSuccess, isUnpinning, dispatch]);

    useEffect(() => {
        if (bulkUnpinPurchaseOrderFailure && isUnpinning) {
            setIsUnpinning(false);
        }
    }, [bulkUnpinPurchaseOrderFailure, isUnpinning]);

    return {
        isPinning: bulkPinningPurchaseOrder || isPinning,
        isUnpinning: bulkUnpinningPurchaseOrder || isUnpinning,
        error: bulkPinPurchaseOrderFailure || bulkUnpinPurchaseOrderFailure,
        success: bulkPinPurchaseOrderSuccess || bulkUnpinPurchaseOrderSuccess,
        bulkPinSuccess: bulkPinPurchaseOrderSuccess,
        bulkUnpinSuccess: bulkUnpinPurchaseOrderSuccess,
        handleBulkPin,
        handleBulkUnpin,
    };
};

export default useBulkPinPurchaseOrder;
